export enum Language {
  Arabic = 1025,
  Azerbaijani = 1068,
  Basque = 1069,
  BosnianLatin = 5146,
  Bulgarian = 1026,
  Catalan = 1027,
  ChineseSimplified = 2052,
  ChineseTraditional = 1028,
  Croatian = 1050,
  Czech = 1029,
  Danish = 1030,
  Dari = 1164,
  Dutch = 1043,
  English = 1033,
  Estonian = 1061,
  Finnish = 1035,
  French = 1036,
  Galician = 1110,
  German = 1031,
  Greek = 1032,
  Hebrew = 1037,
  Hindi = 1081,
  Hungarian = 1038,
  Indonesian = 1057,
  Irish = 2108,
  Italian = 1040,
  Japanese = 1041,
  Kazakh = 1087,
  Korean = 1042,
  Latvian = 1062,
  Lithuanian = 1063,
  Macedonian = 1071,
  Malay = 1086,
  Norwegian = 1044,
  Polish = 1045,
  PortugueseBrazil = 1046,
  PortuguesePortugal = 2070,
  Romanian = 1048,
  Russian = 1049,
  SerbianCyrillicRs = 10266,
  SerbianLatin = 2074,
  SerbianLatinRs = 9242,
  Slovak = 1051,
  Slovenian = 1060,
  Spanish = 3082,
  Swedish = 1053,
  Thai = 1054,
  Turkish = 1055,
  Ukrainian = 1058,
  Vietnamese = 1066,
  Welsh = 1106
}

export const LanguageName = new Map<number, string>([
  [Language.Arabic, "Arabic"],
  [Language.Azerbaijani, "Azerbaijani"],
  [Language.Basque, "Basque"],
  [Language.BosnianLatin, "Bosnian (Latin)"],
  [Language.Bulgarian, "Bulgarian"],
  [Language.Catalan, "Catalan"],
  [Language.ChineseSimplified, "Chinese (Simplified)"],
  [Language.ChineseTraditional, "Chinese (Traditional)"],
  [Language.Croatian, "Croatian"],
  [Language.Czech, "Czech"],
  [Language.Danish, "Danish"],
  [Language.Dari, "Dari"],
  [Language.Dutch, "Dutch"],
  [Language.English, "English"],
  [Language.Estonian, "Estonian"],
  [Language.Finnish, "Finnish"],
  [Language.French, "French"],
  [Language.Galician, "Galician"],
  [Language.German, "German"],
  [Language.Greek, "Greek"],
  [Language.Hebrew, "Hebrew"],
  [Language.Hindi, "Hindi"],
  [Language.Hungarian, "Hungarian"],
  [Language.Indonesian, "Indonesian"],
  [Language.Irish, "Irish"],
  [Language.Italian, "Italian"],
  [Language.Japanese, "Japanese"],
  [Language.Kazakh, "Kazakh"],
  [Language.Korean, "Korean"],
  [Language.Latvian, "Latvian"],
  [Language.Lithuanian, "Lithuanian"],
  [Language.Macedonian, "Macedonian"],
  [Language.Malay, "Malay"],
  [Language.Norwegian, "Norwegian (Bokmål)"],
  [Language.Polish, "Polish"],
  [Language.PortugueseBrazil, "Portuguese (Brazil)"],
  [Language.PortuguesePortugal, "Portuguese (Portugal)"],
  [Language.Romanian, "Romanian"],
  [Language.Russian, "Russian"],
  [Language.SerbianCyrillicRs, "Serbian (Cyrillic, Serbia)"],
  [Language.SerbianLatin, "Serbian (Latin)"],
  [Language.SerbianLatinRs, "Serbian (Latin, Serbia)"],
  [Language.Slovak, "Slovak"],
  [Language.Slovenian, "Slovenian"],
  [Language.Spanish, "Spanish"],
  [Language.Swedish, "Swedish"],
  [Language.Thai, "Thai"],
  [Language.Turkish, "Turkish"],
  [Language.Ukrainian, "Ukrainian"],
  [Language.Vietnamese, "Vietnamese"],
  [Language.Welsh, "Welsh"]
]);
